import factory from '@atlassian/trello-error-ext';
// eslint-disable-next-line @trello/no-module-logic
export const AttachmentTypeRestrictedError = factory(
  'Attachment::TypeRestricted',
);
